import React, { Component } from 'react';
import './sensorSet.less';
import PubSub from 'pubsub-js'
import { meshLog, SPRemove, SPGet, SPSet } from "../../../../utils/spUtils";
import { getDevicesByGroupId } from '../../../../utils/meshUtils';
import { convertSecondsToTime } from '../../../../utils/dataUtils';
import { sendOpcode_group_light, sendOpcode_group_onoff, sendOpcode_identify, sendOpcode_group_state, sendOpcode_devices_state } from '../../../../utils/opcodeUtils';
import light_normal3 from "../../../../imgs/mesh/light_normal3.png";
import btn_on from "../../../../imgs/mesh/btn_on.png";
import btn_off from "../../../../imgs/mesh/btn_off.png";
import sync_on from "../../../../imgs/mesh/sync_on.png";
import sync_off from "../../../../imgs/mesh/sync_off.png";
import montion from "../../../../imgs/item/montion.png";
import devices from "../../../../imgs/item/devices.png";
import btn_refresh from "../../../../imgs/btn/btn_refresh.png";
import arrow_right from "../../../../imgs/btn/arrow_right.png";
import sensor_on from "../../../../imgs/btn/btn_on.png";
import sensor_off from "../../../../imgs/btn/btn_off.png";

import { SET_ControlPageDetailPage_DIALOG_HIDE, SPIN_DIALOG_SHOW, SPIN_DIALOG_HIDE, } from "../../../../const/infoConst"


export default class SensorSet extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOn: true,
            cctLevel: 50,
            cctLevelValue: 1000,
            dimLevel: 50,
            groupInfo: '',
            devices: [], //group数据
            motionSensorEnabled: true,
            isEnableVGroup: false

        }
    }

    componentDidMount() {
        this.updateGroupUI();
        PubSub.subscribe('updateGroupdataUI', (msg, data) => {
            this.updateGroupUI();
        })

        PubSub.unsubscribe("mqttGroupState")
        PubSub.subscribe('mqttGroupState', (msg, index) => {
            //状态更新
            this.updateGroupUI();
        })
        meshLog('更新灯的状态',);
        PubSub.unsubscribe("mqttDeviceState")
        PubSub.subscribe('mqttDeviceState', (msg, index) => {
            //状态更新
            this.updateGroupUI();
        })
    }

    updateGroupUI() {
        meshLog('group渲染第一步', this.props);
        const groupInfo = JSON.parse(SPGet("groupInfo"))
        const cctModeArray = groupInfo.cctModeArray
        const cctLevelValue = ((cctModeArray[cctModeArray.length - 1] - cctModeArray[0]) * (groupInfo.cctLevel) / 400) + cctModeArray[0]
        const motionModel = groupInfo.motionModel

        this.setState({
            groupInfo: groupInfo,
            cctLevel: groupInfo.cctLevel,
            cctLevelValue: cctLevelValue,
            dimLevel: groupInfo.dimLevel,
            isOn: groupInfo.isOnOff,
            motionSensorEnabled: motionModel.isEnabled,
            isEnableVGroup: groupInfo.isEnableVGroup,
            // groupDevices: groupDevices,
            devices: getDevicesByGroupId(groupInfo.groupID), //group数据
        })
    }

    handleToggle = (key) => {
        this.setState((prev) => ({ [key]: !prev[key] }));
        sendOpcode_group_onoff(key);
    };

    //原本的处理方法
    handleChange = (key, value) => {
        //边输入边赋值
        meshLog('value', value);
        meshLog('key', key);
        this.setState({ [key]: value });
        if (key == 'isOn') {
            const isOn = this.state.isOn
            this.setState({
                isOn: !isOn
            });
            sendOpcode_group_light(key, !isOn);
        } else if (key == 'motionSensorEnabled') {
            const motionSensorEnabled = this.state.motionSensorEnabled
            meshLog('motionSensorEnabled', motionSensorEnabled);
            this.setState({
                motionSensorEnabled: !motionSensorEnabled
            });
            //控制命令之后再发
            meshLog('motionSensorEnabled', !motionSensorEnabled);
            sendOpcode_group_onoff("motionSensorEnabled");
        }
        else {
            sendOpcode_group_light(key, value);
            this.setState({ [key]: value });
        }

    };

    handleChange1 = (key, value) => {
        //边输入边赋值
        meshLog('value', value);
        meshLog('key', key);
        this.setState({ [key]: value });
        if (key == 'cctLevel') {
            const groupInfoLast = JSON.parse(SPGet("groupInfo"))
            const groupList = JSON.parse(SPGet("groupList"))
            let groupInfo = groupList.find(item => item.groupID == groupInfoLast.groupID)
            const cctModeArray = groupInfo.cctModeArray
            const cctLevelValue = ((cctModeArray[cctModeArray.length - 1] - cctModeArray[0]) * (value) / 400) + cctModeArray[0]
            this.setState({ cctLevelValue: cctLevelValue });
        }
    };

    handleMouseUp = (key, value) => {
        //边输入边赋值 鼠标离开发指令，主要是针对调光调色
        meshLog('handleMouseUphandleMouseUp', value);
        sendOpcode_group_light(key, value);
    };

    //显示单灯信息
    controlPageDetailContainer = (device) => {
        SPSet('controlDevice', JSON.stringify(device))
        PubSub.publish(SET_ControlPageDetailPage_DIALOG_HIDE, device)//控制ControlPageDetailPage弹框显示
    }

    controlIsEnableVGroup = () => {
        //获取isEnableVGroup,虚拟组的开关
        const isEnableVGroup = this.state.isEnableVGroup
        this.setState({
            isEnableVGroup: !isEnableVGroup
        });
        meshLog('isEnableVGroup', !isEnableVGroup);
        //控制命令
        sendOpcode_group_light("isEnableVGroup", !isEnableVGroup);
        PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
        setTimeout(() => {
            PubSub.publish(SPIN_DIALOG_HIDE, '');
        }, 2000)

    }

    //group下面跳转
    gotoSensrorSettings = () => {
        PubSub.publish('gotoSensrorSettings', '')//显示SensrorSettings界面
    }
    gotoSensorDevice = () => {
        PubSub.publish('gotoSensorDevice', '')//显示显示sensorDevice界面
    }

    render() {
        const { isOn, cctLevel, dimLevel, cctLevelValue, motionSensorEnabled, isEnableVGroup } = this.state;

        return (
            <div className="sensor-container">
                {/* 组名和电源按钮 */}
                <div className="group-header">
                    <div className="action-title">
                        <img src={light_normal3} />
                        <span>{this.state.groupInfo.name}</span>
                    </div>

                    <div className="sensor_line"></div>
                    <div>
                        <img className="onoff-icon" src={motionSensorEnabled ? sensor_on : sensor_off} onClick={(e) => this.handleChange('motionSensorEnabled', parseInt(e.target.value))} />
                        <span style={{ fontSize: "10px", marginLeft: "-48px" }}>Sensor Mode</span>
                    </div>

                    <div className="sensor_line"></div>
                    <img className="onoff-icon" src={isEnableVGroup ? sync_on : sync_off} onClick={() => { this.controlIsEnableVGroup() }} />
                    <div className="sensor_line"></div>
                    <img className="onoff-icon" src={isOn ? btn_on : btn_off} onClick={(e) => this.handleChange('isOn', parseInt(e.target.value))} />
                    <div className="sensor_line"></div>
                </div>
                {/* Dim Level */}
                <div className="dim-level">
                    <div className="label">Dim level</div>
                    <div className="value-boxes">
                        <div className="sensor_blue">0W</div>
                        <div className="box">{dimLevel}%</div>
                    </div>
                </div>
                {/* Dim滑动条 */}
                <input type="range"
                    min="0"
                    max="100"
                    value={dimLevel}
                    className="slider"
                    onMouseUp={(e) => this.handleMouseUp('dimLevel', parseInt(e.target.value))}
                    onChange={(e) => this.handleChange1('dimLevel', parseInt(e.target.value))} />
                {/* CCT Tunable */}
                <div className="dim-level">
                    <div className="label">CCT Tunable</div>
                    <div className="value-boxes">
                        {/* <div className="box blue">0W</div> */}
                        <div className="box">{cctLevelValue}k</div>
                    </div>

                </div>
                {/* 滑动条 */}
                <input type="range"
                    min="0"
                    max="400"
                    value={cctLevel}
                    className="slider"
                    onMouseUp={(e) => this.handleMouseUp('cctLevel', parseInt(e.target.value))}
                    onChange={(e) => this.handleChange1('cctLevel', parseInt(e.target.value))} />
                {/* 灯数据 */}
                <div className="line_space"></div>

                <div className="device-header" onClick={() => { this.gotoSensrorSettings() }} >
                    <div className="action-title">
                        <img className='icon' src={montion} />
                        <span>Sensor Settings</span>
                    </div>
                    <div className="action-group">
                        {/* <img className="refresh-icon" onClick={() => { this.controlRefreshDevices() }} src={btn_refresh} /> */}
                        <img className="arrow-icon" src={arrow_right} />
                    </div>
                </div>

                <div className="device-header" onClick={() => { this.gotoSensorDevice() }} >
                    <div className="action-title">
                        <img className='icon' src={devices} />
                        <span>Single Device Control</span>
                    </div>
                    <div className="action-group">
                        {/* <img className="refresh-icon" onClick={() => { this.controlRefreshDevices() }} src={btn_refresh} /> */}
                        <img className="arrow-icon" src={arrow_right} />
                    </div>
                </div>

            </div>
        );
    }
}
